import React from "react";
import OrviAnimation from "../../images/OrviAnimationLight.gif";
import BackgroundAnimated from "../BackgroundAnimated/BackgroundAnimated";

function LoadingScreen() {
  return (
    <div className="relative overflow-hidden">
      <BackgroundAnimated />
      <div className="h-screen w-screen flex justify-center items-center">
        <div className=" flex justify-center items-center">
          <img src={OrviAnimation} className="w-full lg:w-9/12" alt="" />
        </div>
      </div>
    </div>
  );
}

export default LoadingScreen;
